import { HeadHeartOutlineIcon } from './HeadHeartOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 0DA85FAF-88F1-4DF1-8DA6-CB3CEFA2A505
 * name head-heart-outline
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/head-heart-outline.svg
 * tags
 */
export const HeadLoveOutlineIcon = HeadHeartOutlineIcon;
export default HeadLoveOutlineIcon